var _defs, _g, _g2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakableLogoMarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "hideBehindBubble",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 220                C370 220 414 262 414 315                C414 340 405 363 388 381                L399 407                L368 395                C353 405 335 411 315 411                C261 411 219 369 219 316                C219 263 261 220 315 220 Z",
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2F6FB6",
    strokeWidth: 9.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#hideBehindBubble)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 300 L113 333 L158 316"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 204,
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 88 C136 120 126 173 131 214 C136 261 150 302 178 320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 88 C270 120 280 171 274 214 C270 251 255 291 228 320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 85 L202 322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 144 C143 151 169 153 202 153 C236 153 266 151 302 145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 204 C132 205 166 205 202 205 C239 205 276 204 322 204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 263 C141 256 169 255 202 255 C231 255 253 257 276 260"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2F6FB6",
    strokeWidth: 9.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315 220              C370 220 414 262 414 315              C414 340 405 363 388 381              L399 407              L368 395              C353 405 335 411 315 411              C261 411 219 369 219 316              C219 263 261 220 315 220 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 340 C286 356 300 364 318 364 C336 364 350 356 360 340"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 298,
    r: 11.5,
    fill: "#2F6FB6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 298,
    r: 11.5,
    fill: "#2F6FB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakableLogoMarkBlue);
export default __webpack_public_path__ + "static/media/speakable_logo_mark_blue.d563fc45eae6daadd67d6c3e51ad0115.svg";
export { ForwardRef as ReactComponent };